/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_S3Inputs */

const en_tut_akses_s3 = /** @type {(inputs: Tut_Akses_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick the statement that you understand the effect, then press **Terapkan akses**.`)
};

const id_tut_akses_s3 = /** @type {(inputs: Tut_Akses_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centang pernyataan bahwa Anda memahami dampaknya, lalu tekan **Terapkan akses**.`)
};

/**
* | output |
* | --- |
* | "Tick the statement that you understand the effect, then press **Terapkan akses**." |
*
* @param {Tut_Akses_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_s3 = /** @type {((inputs?: Tut_Akses_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_s3(inputs)
	return en_tut_akses_s3(inputs)
});